import { useState } from 'react';
import { useWorkflow } from '../WorkflowContext';

const AGENTS_1 = ['MFX OS Chief AI', 'CSR AI', 'Logistics AI', 'Prepress AI', 'Production AI', 'Quality AI'];
const AGENTS_2 = ['CSR AI', 'Logistics AI', 'Prepress AI', 'Production AI', 'Quality AI', 'Accounting AI'];

const DIRECTORY = [
  ['OS Chief AI', 'Global visibility, risk, client/job status, cross-functional answers.'],
  ['CSR AI', 'Intake, client profile, communication drafts, follow-ups.'],
  ['Logistics AI', 'Materials, inventory, vendor PO, receiving, shipping readiness.'],
  ['Prepress AI', 'Artwork, proofs, blueprints, SKU technical readiness.'],
  ['Production AI', 'Job tickets, scheduling, machine/run readiness.'],
  ['Quality AI', 'Checks, holds, releases, CAPA/NCR, SQF evidence.'],
];

export default function CommandRoom() {
  const wf = useWorkflow();
  const [q, setQ] = useState('What is stopping Acme’s sample request from being completed and what should happen next?');
  const [a1, setA1] = useState(AGENTS_1[0]);
  const [a2, setA2] = useState(AGENTS_2[0]);

  return (
    <>
      <div className="page-head">
        <div>
          <div className="page-title">AI Command Room</div>
          <div className="page-sub">Invite department agents to answer cross-functional questions using scoped system data.</div>
        </div>
      </div>

      <div className="grid sidebar-layout">
        <div className="card">
          <div className="card-header"><div><h3>Command Room</h3><p>Invite agents into the same conversation.</p></div></div>
          <div className="card-body">
            <div className="form-grid">
              <div className="field full"><label>Question</label><textarea value={q} onChange={(e) => setQ(e.target.value)} /></div>
              <div className="field"><label>Invite Agent 1</label><select value={a1} onChange={(e) => setA1(e.target.value)}>{AGENTS_1.map((a) => <option key={a}>{a}</option>)}</select></div>
              <div className="field"><label>Invite Agent 2</label><select value={a2} onChange={(e) => setA2(e.target.value)}>{AGENTS_2.map((a) => <option key={a}>{a}</option>)}</select></div>
            </div>
            <div style={{ marginTop: 14 }}><button className="btn primary" onClick={() => wf.askAgents(q, a1, a2)}>Ask Invited Agents</button></div>
            <div className="ai-output" style={{ marginTop: 14, minHeight: 240 }}>{wf.agentConversation}</div>
          </div>
        </div>
        <div className="card">
          <div className="card-header"><div><h3>Agent Directory</h3><p>Department agents and their scoped functions.</p></div></div>
          <div className="card-body">
            <div className="agent-grid">
              {DIRECTORY.map(([n, d]) => (
                <div className="agent-card" key={n}><strong>{n}</strong><p>{d}</p></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
